module.exports = __webpack_public_path__ + "img/logo-asli-white.04d4d080.png";